export enum NotificationType {
  error = 0,
  info = 1,
  success = 2,
  warning = 3,
}
